
import { FC } from 'react';

interface IOption {
  label: string;
  key: any;
}

export interface ICheckboxesProps {
  onChange: (values: any) => void;
  name?: string;
  value?: any[];
  error?: string;
  readOnly?: boolean;
  options: IOption[];
}

export const Checkboxes: FC<ICheckboxesProps> = ({ onChange, options, value, error, name, readOnly }) => {
  let classes = 'cb-checkbox';
  if (readOnly)
    classes += ' cb-disabled';

  const values = value || [];
  return <>{options.map((option) => {
    const checked = values.includes(option.key);
    const keys = [...values];
    return <div key={`${name}-${option.key}-checkbox`} className={classes}><label>
      <input onChange={(e) => {
        const key = option.key;
        const pos = keys.indexOf(key);
        if (!e.target.checked) {
          if (pos >= 0) keys.splice(pos, 1);
        } else {
          if (pos < 0) keys.push(key);
        }
        onChange(keys);
      }} disabled={readOnly} type="checkbox" value={option.key} checked={checked} style={{ marginBottom: '5px' }} /> {option.label}
    </label></div>;
  })}
    {
      error &&
      <span style={{ marginTop: '2px', marginBottom: '8px' }} className='cb-input-helper cb-validation-error'>{error}</span>
    }
  </>;
};

export interface ICheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  label: React.ReactNode | string;
  error?: string;
}

export const Checkbox: FC<ICheckboxProps> = ({ onChange, label, name, value, disabled, checked, error}) => {
  let classes = 'cb-checkbox';
  if (disabled) classes += ' cb-disabled';
  return <><div className={classes}><label>
    <input name={name} onChange={onChange} disabled={disabled} type="checkbox" value={value} checked={checked}/> {label}
  </label></div>
    {
      error &&
      <span style={{ marginTop: '2px', marginBottom: '8px' }} className='cb-input-helper cb-validation-error'>{error}</span>
    }</>;
};
